import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Group, Center, Text, Loader, Grid, Stack, Flex } from "@mantine/core";
import { IconSchool } from "@tabler/icons-react";
import StatsResume from "./StatsResume";
import BLACK_LIST from "../../enums/CareersBlackList";
import { notifyError } from "../../components/Toast";
import useActiveProcess from '../../hooks/useActiveProcess'
import useActivePermission from "../../hooks/useActivePermission";
import { Category } from "../../enums/PermissionsEnums";

const CareerList = ({ facultieId, allowAll, onSelectUnit }) => {
  const { user } = useSelector((state) => state.auth);

  const activeProcess = useActiveProcess();
  const activePermission = useActivePermission();

  const [careers, setCareers] = useState([]);
  const [loadingCareers, setLoadingCareers] = useState(true);

  const fetchCareers = async (codFaculty, etapa = null, version = null, user) => {
    try {
      const query = new URLSearchParams({
        etapa: etapa ?? "",
        version: version ?? "",
      }).toString();

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}reportes/${activeProcess.Id}/evaluacion/${codFaculty}/carreras/resume?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al obtener las carreras");
      }

      const data = await response.json();
      const filteredData = data.filter((item) => !BLACK_LIST.includes(item.Codigo));
      setCareers(filteredData); 

    } catch (error) {
      notifyError("Error al obtener las carreras");
    } finally {
      setLoadingCareers(false);
    }
  };

  useEffect(() => {
    setLoadingCareers(true);
    fetchCareers(facultieId, null, null, user);
  }, [facultieId, user]);
  
  const memoizedCareers = useMemo(() => careers, [careers]);

  const canAccessCareer = (perm,careerCode) => {
    if(allowAll){
      return true;
    }else{
      const isCar = perm.permiso.categoria?.Id.toUpperCase() === Category.CARRERA;
      const unitId = perm.permiso.EntityId.toUpperCase().trim();

      if(isCar && unitId === careerCode.toUpperCase())
        return true;
    }
  }

  if (loadingCareers && memoizedCareers.length === 0) {
    return (
      <Center>
        <Loader type="dots" size="md" mr={"sm"} color="#E72166" />
      </Center>
    );
  }

  return (
    <>
      {memoizedCareers.map((career, index) => { 
        const isAllowed = canAccessCareer(activePermission,career.Codigo.toUpperCase());

        return (
          <Box mt="sm" key={index} className="item-card">
            <Grid justify="space-between" align="center">
              <Grid.Col span={{ base: 12, md: 5, lg: 4 }}>
                <Flex gap="sm" justify="flex-start" align="center" direction="row" wrap="nowrap">
                  <IconSchool size={20} style={{ flexShrink: 0 }} />
                  <Text ml={10} fw={500} size="md">
                    <Text span inherit fw={600}/*c={"#E72166"}*/> {career.Codigo}</Text>{" "} - {career.Descripcion ?? "[No disponible]"}
                  </Text>
                </Flex>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 7, lg: 8 }}>
                <StatsResume
                  unitType="c"
                  countEvidences={career.Resumen?.Evidencias}
                  countWeakness={career.Resumen?.Debilidades}
                  countStrengths={career.Resumen?.Fortalezas}
                  buttonVisible={isAllowed}
                  onClick={() => onSelectUnit(career.Codigo)}
                />
              </Grid.Col>
            </Grid>
          </Box>
        );
      })}
    </>
  );
};

export default CareerList;